import { getLogger } from '../../libs/logger';

export const logger = getLogger('postCallSurvey');
